import React, { useState, useEffect } from 'react';

import styled, { css, keyframes } from 'styled-components';
import { shake } from 'react-animations';
import isEmpty from 'lodash/isEmpty';

import connectFinalFormField from '../../libs/final-form/connectFinalFormField';

import Alert from '../basic/Alert';
import QRScannerModal from '../Utility/Camera/QRScannerModal';

const shakeAnimation = keyframes`${shake}`;

const InputGroup = styled.div`
  display: flex;
  overflow: hidden;
  flex-direction: row;
  border-radius: 4px;
  width: 100%;
  outline: none;
  font-size: 16px;
  border: solid 1px ${({ theme: { colors } }) => colors.light.neutral};
  transition: all ease 0.4s;
  &:focus,
  &:active {
    background-color: ${({ theme: { colors } }) => colors.light.primary};
    border: solid 1px ${({ theme: { colors } }) => colors.light.secondary};
  }
  ${props => {
    return (
      props['data-error'] &&
      css`
        border-color: ${props.theme.colors.danger.primary} !important;
      `
    );
  }}
`;

const InputWrapper = styled.input`
  padding: 12px 20px;
  flex: 1;
  outline: none;
  border: 0px;
  transition: all ease 0.4s;
  min-width: 100px;
  ::placeholder {
    color: ${({ theme: { colors } }) => colors.light.secondary};
  }
`;

const InputLabel = styled.label`
  display: block;
  color: ${({ theme: { colors } }) => colors.dark.light};
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 10px;
`;

const InputUnit = styled.div`
  margin: 5px;
  padding: 10px;
  height: 100%;
  font-weight: 900;
  border-radius: 2px;
  color: ${({ theme: { colors } }) => colors.gray.neutral};
  background-color: ${({ theme: { colors } }) => colors.gray.primary};
`;

const TextInput = ({
  id,
  label,
  type,
  error,
  helpText,
  unit,
  active,
  submitting,
  enableqr,
  onQRScan = v => v,
  onChange,
  ...rest
}) => {
  const [isShake, setIsShake] = useState(false);
  useEffect(() => {
    if (error && active) {
      setIsShake(true);
      setTimeout(() => {
        setIsShake(false);
      }, 500);
    }
  }, [active, isEmpty(error)]);
  return (
    <div
      css={`
        margin: 0 0 24px 0;
      `}
    >
      <InputLabel htmlFor={id}>{label}</InputLabel>
      <InputGroup
        data-error={error}
        css={
          isShake &&
          css`
            animation: 1s ${shakeAnimation};
          `
        }
      >
        <InputWrapper type={type || 'text'} onChange={onChange} {...rest} />
        {!isEmpty(unit) && <InputUnit>{unit}</InputUnit>}
        {!!enableqr && (
          <QRScannerModal onScan={result => onChange(onQRScan(result))}>
            {({ show }) => (
              <div
                onClick={show}
                css={css`
                  cursor: pointer;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 40px;
                  padding: 0 5px;
                  /* border: 1px solid ${({ theme: { colors } }) => colors.gray.neutral}; */
                `}
              >
                <img src="https://s3-ap-southeast-1.amazonaws.com/static.rupiahtoken.com/images/icon/scan-qrcode-icon.png" />
              </div>
            )}
          </QRScannerModal>
        )}
      </InputGroup>
      {(!isEmpty(error) || !isEmpty(helpText)) && (
        <div
          css={`
            margin-top: 12px;
          `}
        >
          {!isEmpty(error) && <Alert type="danger" small description={error} />}
          {!isEmpty(helpText) && <Alert small type="warning" description={helpText} />}
        </div>
      )}
    </div>
  );
};

export default connectFinalFormField(TextInput);
